import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTheme } from 'styled-components';

import adminApi from '../../../APIs/admin';
import jobsApi from '../../../APIs/jobs';
import UploadedPDFView from '../../../components/TechnicianJobs/ReviewAndSend/UploadedPDFView';
import {
  Button,
  Divider,
  NavigateBack,
  SelectDropdown,
  Typography,
} from '../../../designComponents';
import { REVIEW_PDF } from '../../../routes/routePaths';
import { RootState } from '../../../store/selectors';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { humanReadableDateWithTime, requestAPI } from '../../../utils';
import { getLatestReview } from '../../../utils/reviews';
import PdfInformation from './PdfInformation';
import { Wrapper } from './style';

const buttonTabData = [
  {
    id: 0,
    label: 'Assign to Fireman',
  },
  // {
  //   id: 1,
  //   label: 'Assign to Draftman',
  // },
];
const PDFDetail = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { jobId } = useParams();

  const [tab, setTab] = useState<number>();
  const [selectedValue, setSelectedValue] = useState('');
  const [loading, setLoading] = useState(false);

  const reviewDetails = useSelector(
    (state: RootState) => state.singleJobProcessReview
  );
  const jobReviewDetails = async (id: string) => {
    try {
      await requestAPI(jobsApi.jobProcessReviewDetails(id));
    } catch (error) {
      console.error(error);
    }
  };
  const departmentUsers = useSelector(
    (state: RootState) => state.departmentUsersData.data
  );

  const getDepartmentUsers = async () => {
    try {
      await requestAPI(adminApi.getDepartmentUsers());
    } catch (error: any) {
      console.error(error);
      toast.error(error);
    }
  };

  const options = departmentUsers
    .filter((user) => user.permissions === 'FIREMAN')
    .map((user) => ({
      id: user._id,
      value: user._id,
      label: user.fullName,
    }));

  useEffect(() => {
    getDepartmentUsers();
  }, []);

  useEffect(() => {
    if (jobId) {
      jobReviewDetails(jobId);
    }
  }, [jobId]);
  const reviews = reviewDetails?.review || [];

  const reviewData = getLatestReview(reviews);

  const handleAssign = async () => {
    try {
      setLoading(true);
      await requestAPI(
        jobsApi.assignReview({
          assigneeUserId: selectedValue,
          jobProcessId: reviewDetails?._id || '',
          reviewId: reviewData?._id || '',
        })
      );
      setLoading(false);
      toast.success('Review assigned successfully');
    } catch (error: any) {
      setLoading(false);
      console.log(error);
      toast.error(error);
    }
  };

  console.log('reviews', reviewDetails);

  const filteredAssignedUser = departmentUsers.find((user) => {
    if (typeof reviewData?.assignedTo === 'string') {
      return user._id === reviewData?.assignedTo;
    }
    return user._id === reviewData?.assignedTo?._id;
  });

  return (
    <Wrapper>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <div className="header">
          <Typography
            variant="heading"
            style={{ color: theme.colors.blueFade }}
            strong
          >
            Complete PDF Detail
          </Typography>
          <div className="heading-inner">
            <Typography
              style={{ color: theme.colors.blueLight }}
              variant="title"
            >
              PDF DETAILS
            </Typography>
            <div className="heading-detail">
              <Typography>
                PDF Uploaded at:{' '}
                {humanReadableDateWithTime(reviewDetails?.createdAt || '')}
              </Typography>
              <Typography>
                PDF Name:
                {/* {reviewData?.pdf?.[0].title} */}
              </Typography>
              <div>{reviewData && <UploadedPDFView review={reviewData} />}</div>
            </div>
          </div>
        </div>
        <Divider />
        <PdfInformation
          designApproach={
            reviewDetails?.jobAndProposal?.proposals?.[0]?.designApproach || ''
          }
          emailAddress={reviewDetails?.createdBy?.emailAddress || ''}
          endDate={reviewDetails?.jobAndProposal?.proposals?.[0]?.endDate || ''}
          experience={
            reviewDetails?.jobAndProposal?.proposals?.[0]?.experience || ''
          }
          fullName={reviewDetails.createdBy?.fullName || ''}
          riskAssessment={
            reviewDetails?.jobAndProposal?.proposals?.[0]?.riskAssessment || ''
          }
          specification={
            reviewDetails?.jobAndProposal?.proposals?.[0]?.specification || ''
          }
          startingDate={
            reviewDetails?.jobAndProposal?.proposals?.[0]?.startingDate || ''
          }
        />
        {reviewDetails.status === 'REVIEW' ? (
          <>
            <Divider />
            <div className="actions">
              <Typography style={{ color: theme.colors.blueLight }}>
                Actions
              </Typography>
              <Button
                style={{ width: '100%' }}
                variant="secondary"
                onClick={() => navigate(REVIEW_PDF)}
              >
                Review PDF
              </Button>
              {reviewData?.assignedTo ? (
                <>
                  <Divider />
                  <Typography
                    variant="normal"
                    strong
                    fontColor="secondary"
                    className="section-title"
                  >
                    Assigned Fireman
                  </Typography>
                  <VerticalSpaceStyled>
                    <InfoRowStyled className="userName">
                      <Typography className="title" fontColor="dark">
                        Fireman name :{' '}
                      </Typography>
                      <Typography className="value">
                        {filteredAssignedUser?.fullName}
                      </Typography>
                    </InfoRowStyled>
                    <InfoRowStyled className="userName">
                      <Typography className="title" fontColor="dark">
                        Department :{' '}
                      </Typography>
                      <Typography className="value">
                        {(filteredAssignedUser?.permissions
                          .charAt(0)
                          .toUpperCase() || '') +
                          filteredAssignedUser?.permissions
                            .slice(1)
                            .toLowerCase()}
                      </Typography>
                    </InfoRowStyled>
                  </VerticalSpaceStyled>
                </>
              ) : (
                <>
                  <div className="assign-heading">
                    <Divider />
                    <Typography>or assign to</Typography>
                    <Divider />
                  </div>
                  <div className="btn">
                    {buttonTabData.map((item, idx) => (
                      <Button
                        onClick={() => setTab(idx)}
                        key={idx}
                        style={{
                          border:
                            item.id === tab
                              ? `1px solid ${theme.colors.secondary}`
                              : `1px solid ${theme.colors.disableButtonText}`,
                        }}
                      >
                        {item.label}
                      </Button>
                    ))}
                  </div>

                  {
                    <div>
                      {tab === 0 ? (
                        <div className="select">
                          <Typography>Select a Fireman</Typography>
                          <SelectDropdown
                            options={options}
                            placeholder="Select a Fireman"
                            selected={selectedValue}
                            onSelect={(value: string) => {
                              setSelectedValue(value);
                            }}
                          />
                          <Button
                            style={{
                              width: '100%',
                              backgroundColor: theme.colors.blueLight,
                              border: `1px solid ${theme.colors.blueLight}`,
                            }}
                            onClick={handleAssign}
                            isLoading={loading}
                          >
                            Send
                          </Button>
                        </div>
                      ) : tab === 1 ? (
                        <div className="select">
                          <Typography>Select a Draftman</Typography>
                          <SelectDropdown
                            options={options}
                            placeholder="Select a Draftman"
                            selected=""
                            onSelect={() => {}}
                          />
                          <Button
                            style={{
                              width: '100%',
                              backgroundColor: theme.colors.blueLight,
                              border: `1px solid ${theme.colors.blueLight}`,
                            }}
                          >
                            Send
                          </Button>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  }
                </>
              )}
            </div>
          </>
        ) : (
          ''
        )}
      </div>
    </Wrapper>
  );
};

export default PDFDetail;
